import { createReducer } from "sc/helpers/reducer";
import {
  CITY_PAGE_LOADED,
  CITY_ADD_REQUEST,
  CITY_ADD_ERROR,
  CITY_UPDATE_REQUEST,
  CITY_UPDATE_ERROR,
  CITY_UPDATED,
} from "../actions/cities";
import { LOCATION_CHANGE } from "react-router-redux/reducer";

export default createReducer(null, {
  [LOCATION_CHANGE]: (state, action) => null,
  [CITY_PAGE_LOADED]: (state, action) => {
    return Object.assign({}, action.payload.city, {
      generalDataSaveInProgress: false,
    });
  },
  [CITY_ADD_REQUEST]: (state, action) =>
    Object.assign({}, state, {
      generalDataSaveInProgress: true,
      generalDataError: "",
    }),
  [CITY_ADD_ERROR]: (state, action) =>
    Object.assign({}, state, {
      generalDataSaveInProgress: false,
      generalDataError: action.payload.message,
    }),
  [CITY_UPDATE_REQUEST]: (state, action) =>
    Object.assign({}, state, {
      generalDataSaveInProgress: true,
      generalDataError: "",
    }),
  [CITY_UPDATE_ERROR]: (state, action) =>
    Object.assign({}, state, {
      generalDataSaveInProgress: false,
      generalDataError: action.payload.message,
    }),
  [CITY_UPDATED]: (state, action) =>
    Object.assign({}, state, { generalDataSaveInProgress: false }),
});



// WEBPACK FOOTER //
// ./src/sc/ui/sites/oncall/reducers/city-reducer.js